import * as Yup from 'yup'

export default Yup.object({
  PublicPage: Yup.boolean().required()
})
